<template>
  <Page>
    <ViewTitle :title="title  +''+ this.username"/>
    <div class="vgs-intro-indent" v-html="labels.Introduction"></div>
    <div v-if="stateName === 'CodeEntry' || stateName === 'CodeDispatched' || stateName === 'SupportRequired' || stateName === 'CodeExpired'">
      <div class="vgs-notifications" v-bind:class="mode">
        <Message :mode="mode" :headline="labels.UserNotActivatedTitle"><p v-html="p(labels.UserNotActivatedText)"></p></Message>
      </div>
    </div>
    <Notifications mode="info"></Notifications>
    <div v-html="this.HomeContent"></div>
    <Message mode="info" :headline="labels.ContactHeadline">
      <b-container class="vgs-info-box" v-if="this.check_responsive_marker('excluding',['phone'])">
        <b-row class="mb-3">
          <b-col class="text-left pl-5"><BaseIcon name="map"></BaseIcon> {{ this.contactInfo.location }} </b-col>
          <b-col class="text-left pl-5"><BaseIcon name="mobile"></BaseIcon> {{ this.contactInfo.phone }} </b-col>
        </b-row>
        <b-row>
          <b-col class="text-left pl-5"><BaseIcon name="fax"></BaseIcon> {{ this.contactInfo.fax }}</b-col>
          <b-col class="text-left pl-5"><BaseIcon name="email"></BaseIcon> <a :href="'mailto:' + this.contactInfo.email">{{ this.contactInfo.email }}</a></b-col>
        </b-row>
      </b-container>
      <div class="vgs-info-box" v-if="this.check_responsive_marker('including',['phone'])">
        <div class="vib-tray">
          <div class="vbt-line"><BaseIcon name="map"></BaseIcon> {{ this.contactInfo.location }} </div>
          <div class="vbt-line"><BaseIcon name="mobile"></BaseIcon> {{ this.contactInfo.phone }} </div>
          <div class="vbt-line"><BaseIcon name="fax"></BaseIcon> {{ this.contactInfo.fax }} </div>
          <div class="vbt-line"><BaseIcon name="email"></BaseIcon> <a :href="'mailto:' + this.contactInfo.email">{{ this.contactInfo.email }}</a></div>
        </div>
      </div>
    </Message>
    
  </Page>
</template>

<script>
import Page from '@/structure/Page.vue'
import ViewTitle from '@/components/ViewTitle.vue'
import Notifications from '@/structure/Notifications.vue'
import Message from '@/structure/Message.vue'
//import NewsletterSignUpForm from '@/forms/NewsletterSignUpForm.vue'
//NewsletterSignUpForm
//<NewsletterSignUpForm></NewsletterSignUpForm>
import BaseIcon from '@/components/BaseIcon.vue'
import { vcm } from '@/mixins/vcm'
import { vvm } from '@/mixins/vvm'
import axios from "axios"
import { getUser, getUserSetting } from '@/services/settingService';

export default {
  mixins: [vcm,vvm],
  name: 'Startpage',
  components: {
    Page, ViewTitle, Message, Notifications, BaseIcon
  },
  data() {
    return {
      labels: {
        Introduction: this.get_scope_translation('Introduction','label'),
        ContactHeadline: this.get_scope_translation('ContactHeadline','label'),
        UserNotActivatedTitle: "",
        UserNotActivatedText: "",
      },
      contactInfo: {
        location: this.$root.get_system_setting('SystemContactLocation',''),
        phone: this.$root.get_system_setting('SystemContactPhone',''),
        fax: this.$root.get_system_setting('SystemContactFax',''),
        email: this.$root.get_system_setting('SystemContactEMail','')
      },
      title : this.$root.get_user_salutation,
      username : localStorage.getItem('vcl_base_user_name'),
      mode: 'alert',
      stateName: this.$store.getters['setting/getUpdatedActivationState'],
      HomeContent: null
    };
  },
  
  beforeMount(){
    try{
       getUser().then((result) => {
          if(result.responseCode === '200' && result.responseMessage === 'User data') {
            this.stateName = result.response.User.StateName;
            try {
              getUserSetting().then((result) => {
                if (result.responseCode === '200' && result.responseMessage) {
                  if(this.stateName === 'CodeEntry' || this.stateName === 'CodeDispatched'){
                    this.labels.UserNotActivatedTitle = result.response.NotificationTitle,
                    this.labels.UserNotActivatedText = result.response.NotificationContent
                  }
                  if(this.stateName === 'CodeExpired'){
                    this.labels.UserNotActivatedTitle = result.response.NotificationTitleState10,
                    this.labels.UserNotActivatedText = result.response.NotificationContentState10
                  }
                  if(this.stateName === 'SupportRequired'){
                    this.labels.UserNotActivatedTitle = result.response.NotificationTitleState84,
                    this.labels.UserNotActivatedText = result.response.NotificationContentState84
                  }
                }
              });
            } catch (e) {
              console.log('Error : ' + e)
            }
          } 
      });
    }
    catch (e) {
      console.log('Error : ' + e)
    }
  },
  async beforeCreate () {
    try {
      const Url = process.env.VUE_APP_BASE_URL + '/v1/pages/home'
      const response = await axios.get(Url, { params: {language: `${this.$root.config.localization.language}`} })
      if (response.data.responseCode === '200' && response.data.response) {
        this.contactInfo.location = response.data.response.ContactAddress
        this.contactInfo.email = response.data.response.ContactEmailAddress
        this.contactInfo.fax = response.data.response.ContactFaxNumber
        this.contactInfo.phone = response.data.response.ContactPhoneNumber
        this.labels.Introduction = response.data.response.Description
        this.title = response.data.response.Title
        this.HomeContent = response.data.response.HomeContent
      }
    } catch (e) {
      console.log('Error : ' + e)
    }
  },
  mounted() {
    setTimeout(() => {
      var doc = document.getElementsByClassName("home-edit-card-img");
      var imgSrc = null;
      for (var i = 0; i < doc.length; i++) {
            imgSrc = doc[i].children[0].src;
            const { pathname } = new URL(imgSrc);
            doc[i].children[0].src = `${this.$root.config.api.img_url}${pathname}`;
      }
    }, 1000);
  },
  methods: {
    receive(dataObject){
      console.log(dataObject)
    },
    p(text) {
      return `<p> ${text} </p>`
    }
  }
}

</script>

<style scoped>
.vgs-info-box a.text-danger {
    color: $primaryColor !important;
}
p > a{
    color: $primaryColor;
    text-decoration: underline;
}


</style>